// src/api/axiosClient.js
// Axios client for login-router — no demo mode, minimal interceptors
import axios from 'axios';
import { TOKEN_KEY, refreshAccessToken } from '@conext/auth';

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  timeout: 20000,
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosClient.interceptors.response.use(
  (response) => {
    if (response.data && typeof response.data === 'object') {
      return response.data;
    }
    return response;
  },
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;
    const isRefreshCall = original?.url?.includes('/auth/refresh');

    if (status === 401 && original && !original._retry && !isRefreshCall && localStorage.getItem('refresh_token')) {
      original._retry = true;
      try {
        const failedToken =
          (original.headers && (original.headers.Authorization || original.headers.authorization)
            ? String(original.headers.Authorization || original.headers.authorization).replace(/^Bearer\s+/i, '')
            : null) || localStorage.getItem("token");
        const newToken = await refreshAccessToken({ backendUrl: axiosClient.defaults.baseURL, failedToken });
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${newToken}`;
        return axiosClient(original);
      } catch (e) {
        return Promise.reject(error);
      }
    }

    console.error('Axios error:', error.response?.status, error.response?.data || error.message);
    return Promise.reject(error);
  },
);

export default axiosClient;
